// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"695":"9f0aac24","839":"159d98aa"}[chunkId] + ".chunk.js";
};